import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { AdminLeaveModalComponent } from '@banyan/modules/standalone/admin-leave-modal/admin-leave-modal.component';
import { Observable, of, switchMap } from 'rxjs';

import { AdminRequestDetailsComponent } from '../components/request/admin-request-details/admin-request-details.component';

export const canExitAdminRequestGuard: CanDeactivateFn<AdminRequestDetailsComponent> =
  (component: AdminRequestDetailsComponent): Observable<boolean> => {
    const dialog = inject(MatDialog);
    if ((!component.adminService.canSubmit() && !component.checkDisabled()) || component.adminService.isProductChange()) {
      const endUseId = component.endUseId;

      const dialogRef = dialog.open(AdminLeaveModalComponent, {
        width: '744px',
        data: { endUseId }
      });

      return dialogRef.afterClosed().pipe(
        switchMap(result => of(result === 'save' || result === 'discard'))
      );
    }
    return of(true);
  };
